import React, { Component } from "react";
import classes from "./DashboardLayout.module.css";

class DashboardLayout extends Component {
  render() {
    return (
      <>
        <div className={classes.ParentContainer}>
          <div className={classes.TopContainer}></div>
        </div>
        <div className={classes.ChildrenContainer}>{this.props.children}</div>
      </>
    );
  }
}

export default DashboardLayout;
